import ReportingManagementLayout from "../layouts/ReportingManagementLayout";
import { NavigationTabs } from "../components/navigation";
import {
    //AccountingReportsPage,
    //ManagementReportsPage,
    ManagementReportsLeagueTablePage,
    ManagementReportsAdviceRegisterPage,
    ManagementReportsNewBusinessRegisterPage
} from "../pages/management-reporting";

const ManagementReportingRoutes = {
    path: 'reporting',
    pathBase: '/management/reporting',
    defaultRoute: 'leaguetablereport',
    roles: [],
    element: ReportingManagementLayout,
    children: [
        { 
            path: "leaguetablereport", 
            icon: "fa-file-signature", 
            label: "League Table",
            roles: [],
            element: ManagementReportsLeagueTablePage
        },
        {
            path: "advice-register",
            icon: "fa-file-signature",
            label: "Advice Register",
            roles: [],
            element: ManagementReportsAdviceRegisterPage
        },
        {
            path: "business-register",
            icon: "sack-dollar",
            label: "New Business Register",
            roles: [],
            element: ManagementReportsNewBusinessRegisterPage
        }
    ]
};

export const ManagementReportingRouteTabs = () => <NavigationTabs pathBase={ManagementReportingRoutes.pathBase} options={ManagementReportingRoutes} />

export default ManagementReportingRoutes;
